import { React } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { subRoutes } from "../../routing/routes";
import LeftnavLinks from "./LeftnavLinks";
import PrivateRoute from "../Login/PrivateRoute";
import Login from "../Login/Login";
import QuickCalcv2NoTransfer from "./QuicCalcv2NoTransfer";

const LeftIndex = () => {
  const location = useLocation();

  return (
    <Routes>
      <Route path="login" element={<Login />} />
       <Route path="quick-calc" element={<QuickCalcv2NoTransfer />} />
      <Route path="" element={<PrivateRoute />}>
        <Route exact path="/" element={<LeftnavLinks />}>
          {subRoutes.map((routeLIst, keys) => {
            return (
              <Route
                key={keys}
                path={routeLIst.path}
                exact
                element={<routeLIst.Element />}
              />
            );
          })}
        </Route>
      </Route>
    </Routes>
  );
};

export default LeftIndex;
